import axios from '../axios'
import {
  checkResponse,
  checkResponseErr,
  getProjectId
} from '../utils'

/**
 * @function createDownload 创建下载任务
 * @param {Object} data {requestPath: 请求案件列表的路径, projectId: 项目 id, taskType: 任务类型, water: 图片是否带水印, picture: 是否带图片, downloadType: 下载方式, clarity: 图片清晰度}
 * @return {Number} id 下载任务 id
 */
const createDownload = (data) => {
  return axios
    .post(`/api/v1/projects/${getProjectId()}/download/task`, data)
    .then(checkResponse)
}

/**
 * @function getDownloadList 获取下载列表
 * @param {Number} page 页码 默认为 1
 * @param {String} params 查询参数 使用 qs 格式化后的参数 {id: 任务id, createdSt: 开始时间, createdEt: 结束时间} 默认为 null
 * @param {String} asc 排序字段
 * @returns {Object} list 返回下载列表 {data: Array 列表数据, pagination: Object 分页}
 */
const getDownloadList = (page = 1, params = null, asc) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/download/task?&page=${page}&per=10&asc=${asc}${
        params ? `&${params}` : ''
      }`
    )
    .then(checkResponse)
}

/**
 * @function deleteDownloadTask 删除下载任务
 * @param {Number} id 任务 id
 * @returns {Boolean} result
 */
const deleteDownloadTask = (id) => {
  return axios
    .delete(`/api/v1/projects/${getProjectId()}/download/task/${id}`)
    .then(checkResponse)
}

/**
 * @function updataDownloadTask 取消/开始下载任务
 * @param {Number} id 任务 id
 * @returns {Boolean} result
 */
const updataDownloadTask = (id) => {
  return axios
    .put(`/api/v1/projects/${getProjectId()}/download/task/${id}`)
    .then(checkResponse)
}

/**
 * @function getOneTask 获取单个下载任务数据
 * @param {Number} id 任务 id
 * @returns {Object} data 请求的单个下载任务的更新数据
 */
const getOneTask = (id) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/download/task/${id}`)
    .then(checkResponse)
}

/**
 * @function exportCase
 * @desc 导出案例方法
 * @param {Number} projectId 项目id
 * @param {Number} typicalId 案例id
 * @param {Number} nodeId 树节点id
 * @return {Object} message 返回下载是否成功
 */
function exportCase (typicalId, nodeId) {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/typicals/${typicalId}/download?node_id=${nodeId}`
    )
    .then(checkResponse)
    .catch(checkResponseErr)
}

/**
 * @function getUcaseRefreshData
 * @desc 获取某个时间后的更新数据
 * @return {Object}
 */
const getUcaseRefreshData = (time) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/download/task/point/list?timestamp=${time}`
    )
    .then(checkResponse)
}

/**
 * @function createPointsDownload
 * @desc 创建点位指标表导出
 * @return {Object}
 */
const createPointsDownload = (data) => {
  return axios
    .post(`/api/v1/projects/${getProjectId()}/download/task/statistical`, data)
    .then(checkResponse)
}
export {
  createDownload,
  getDownloadList,
  deleteDownloadTask,
  updataDownloadTask,
  getOneTask,
  exportCase,
  getUcaseRefreshData,
  createPointsDownload
}
